import { cn } from '../../lib/cn';

export function Brand({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <span className={cn('inline-flex items-center', className)}>
      <span className="font-display text-lg font-bold tracking-tight text-inherit">
        {compact ? 'R' : 'RoboMiD'}
      </span>
    </span>
  );
}
